
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.324 7.5h3.5V4l-1.34 1.34L6.82 1.676 4.496 4 .996.5l-.82.82 4.32 4.32L6.82 3.317 9.664 6.16 8.324 7.5z","fill":"#ff3737"}})])
          )
        }
      }
    